// /* import {NgModule} from '@angular/core';
// import {APOLLO_OPTIONS} from 'apollo-angular';
// import {ApolloClientOptions, ApolloLink, DefaultOptions, InMemoryCache} from '@apollo/client/core';
// import {HttpLink} from 'apollo-angular/http';
// import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
// import { setContext } from "@apollo/client/link/context";
// import { onError } from "@apollo/client/link/error";
// import { environment } from '../environments/environment';

// const uri = environment.hasura_uri;
// const wsUri = environment.hasura_subscriptions_uri; // Hasura WebSocket endpoint

// export function createApollo(httpLink: HttpLink, authService: NbAuthService): ApolloClientOptions<any> {

//   const defaultOptions: DefaultOptions = {
//     watchQuery: {
//         fetchPolicy: 'cache-and-network',
//         errorPolicy: 'ignore',
//     },
//     query: {
//         fetchPolicy: 'network-only',
//         errorPolicy: 'all',
//     },
//     mutate: {
//         errorPolicy: 'all'
//     },
//   };

//   const basicLink: any = setContext((operation, context) => ({
//     headers: {
//       Accept: 'charset=utf-8'
//     }
//   }));

//   const authLink: any = setContext((operation, context) => {

//     let token = null;

//     authService.onTokenChange()
//     .subscribe((res: NbAuthJWTToken) => {
//       if (res.isValid()) {
//         token = res;
//       }
//     });

//     if (token === null) {
//       return {};
//     } else {
//       return {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           // HACK: Questo Header serve anche se il ruolo è già all'interno degli Hasura-Claims.
//           // Se non metti questo Header, Hasura da errore
//           'X-Hasura-User-Id': token.getPayload()["hasura_claims"]["x-hasura-user-id"],
//           'X-Hasura-Role': token.getPayload()["hasura_claims"]["x-hasura-role"],
//         }
//       };
//     }
//   });

//   const errorLink: any = onError(({ graphQLErrors, networkError }) => {
//     if (graphQLErrors) {
//         graphQLErrors.map(({ message, locations, path }) => console.log(
//                 `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
//           ),
//         );
//     }

//     if (networkError) {
//         console.log("Network error]:" , networkError);
//     }
//   });

//   const link = ApolloLink.from([errorLink, basicLink, authLink, httpLink.create({ uri: uri, withCredentials: true })]);


//   const cache = new InMemoryCache({
//     addTypename: false,
//   });

//   return {
//     link,
//     cache,
//     defaultOptions,
//   };
// }

// @NgModule({
//   providers: [
//     {
//       provide: APOLLO_OPTIONS,
//       useFactory: createApollo,
//       deps: [HttpLink, NbAuthService],
//     },
//   ],
// })
// export class GraphQLModule {}
//  */







// import { NgModule } from '@angular/core';
// import { APOLLO_OPTIONS } from 'apollo-angular';
// import {
//   ApolloClientOptions,
//   ApolloLink,
//   DefaultOptions,
//   InMemoryCache,
//   split,
// } from '@apollo/client/core';
// import { HttpLink } from 'apollo-angular/http';
// import { NbAuthJWTToken, NbAuthService, NbAuthToken } from '@nebular/auth';
// import { setContext } from '@apollo/client/link/context';
// import { onError } from '@apollo/client/link/error';
// import { getMainDefinition } from '@apollo/client/utilities';
// import { WebSocketLink } from '@apollo/client/link/ws'; // WebSocket Link
// import { environment } from '../environments/environment';

// const uri = environment.hasura_uri; // Hasura HTTP endpoint
// const wsUri = environment.hasura_subscriptions_uri; // Hasura WebSocket endpoint

// export function createApollo(httpLink: HttpLink, authService: NbAuthService): ApolloClientOptions<any> {
//   const defaultOptions: DefaultOptions = {
//     watchQuery: {
//       fetchPolicy: 'cache-and-network',
//       errorPolicy: 'ignore',
//     },
//     query: {
//       fetchPolicy: 'network-only',
//       errorPolicy: 'all',
//     },
//     mutate: {
//       errorPolicy: 'all',
//     },
//   };

//   // Basic Link
//   const basicLink: any = setContext(() => ({
//     headers: {
//       Accept: 'charset=utf-8',
//     },
//   }));

//   // Auth Link
//   const authLink: any = setContext(() => {
//     let token: NbAuthJWTToken | null = null;

//     authService.onTokenChange().subscribe((res: NbAuthToken) => {
//       if (res.isValid()  && res instanceof NbAuthJWTToken) {
//         token = res;
//       }
//     });

//     if (token === null) {
//       return {};
//     } else {
//       const jwtToken = token as NbAuthJWTToken;
//       return {
//         headers: {
//           Authorization: `Bearer ${jwtToken}`,
//           'X-Hasura-User-Id': jwtToken.getPayload()['hasura_claims']['x-hasura-user-id'],
//           'X-Hasura-Role': jwtToken.getPayload()['hasura_claims']['x-hasura-role'],
//         },
//       };
//     }
//   });

//   // Error Link
//   const errorLink: any = onError(({ graphQLErrors, networkError }) => {
//     if (graphQLErrors) {
//       graphQLErrors.forEach(({ message, locations, path }) => {
//         console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
//       });
//     }
//     if (networkError) {
//       console.error('[Network error]:', networkError);
//     }
//   });

//   // HTTP Link
//   const http = httpLink.create({ uri, withCredentials: true });

//   // WebSocket Link
//   const wsLink = new WebSocketLink({
//     uri: wsUri,
//     options: {
//       reconnect: true,
//       connectionParams: async () => {
//         let token: NbAuthJWTToken | null = null;
//         await authService.onTokenChange().toPromise().then((res) => {
//           if (res && res.isValid() && res instanceof NbAuthJWTToken) {
//             token = res;
//           }
//         });

//         // await authService.onTokenChange().toPromise().then((res) => {
//         //    if (res && res.isValid()) {
//         //   token = res;
//         // }
//         //   if (res.isValid()) {
//         //     token = res;
//         //   }
//         // });

//         const jwtToken = token!;
//         return {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'X-Hasura-User-Id': jwtToken.getPayload()['hasura_claims']['x-hasura-user-id'],
//             'X-Hasura-Role': jwtToken.getPayload()['hasura_claims']['x-hasura-role'],
//           },
//         };
//       },
//     },
//   });

//   // Split Link: Direct subscriptions to WebSocket and queries/mutations to HTTP
//   const link = split(
//     ({ query }) => {
//       const definition = getMainDefinition(query);
//       return (
//         definition.kind === 'OperationDefinition' &&
//         definition.operation === 'subscription'
//       );
//     },
//     wsLink, // Subscriptions over WebSocket
//     ApolloLink.from([errorLink, basicLink, authLink, http]) // Queries/Mutations over HTTP
//   );

//   const cache = new InMemoryCache({
//     addTypename: false,
//   });

//   return {
//     link,
//     cache,
//     defaultOptions,
//   };
// }

// @NgModule({
//   providers: [
//     {
//       provide: APOLLO_OPTIONS,
//       useFactory: createApollo,
//       deps: [HttpLink, NbAuthService],
//     },
//   ],
// })
// export class GraphQLModule {}












import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';

import {
  ApolloClientOptions,
  InMemoryCache,
  ApolloLink,
  split,
  DefaultOptions,
} from '@apollo/client/core';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';

import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { environment } from '../environments/environment';
import { filter, firstValueFrom } from 'rxjs';
import { fromPromise } from '@apollo/client/link/utils';
import type { GraphQLFormattedError } from 'graphql';
import { RateLimitNotifier } from './_helpers/rate-limit';
import { RequestCacheService } from './_helpers/request-cache.service';
import { TokenRefreshService, hasuraAuthHeaders } from './_helpers/token-refresh.service';

const uri = environment.hasura_uri;
const wsUri = environment.hasura_subscriptions_uri;

export function createApollo(
  httpLink: HttpLink,
  authService: NbAuthService,
  tokens: TokenRefreshService,
  rateLimit: RateLimitNotifier,
  requestCache: RequestCacheService,
): ApolloClientOptions<any> {
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  };

  const basicLink = setContext(() => ({
    headers: { Accept: 'charset=utf-8' },
  }));

  // Every operation gets a valid access token: expired/expiring ones are refreshed first.
  const authLink = setContext(async (_, { headers }) => {
    const token = await tokens.getValidToken();
    return token ? { headers: { ...headers, ...hasuraAuthHeaders(token) } } : {};
  });

  const isJwtError = (error: GraphQLFormattedError) =>
    error.extensions?.['code'] === 'invalid-jwt' || /JWTExpired|JWSError|jwt expired/i.test(error.message || '');

  const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
    // Hasura answers 200 + "invalid-jwt" when the token expired: refresh once and replay the operation.
    // Rate-limited operations are shown to the user and never replayed.
    if (graphQLErrors?.some(error => rateLimit.handle(error))) return undefined;
    if (graphQLErrors?.some(isJwtError) && !operation.getContext()['tokenRetried']) {
      operation.setContext({ tokenRetried: true });
      return fromPromise(tokens.getValidToken(true, `GraphQL ${operation.operationName}: ${graphQLErrors.find(isJwtError)?.message}`)).flatMap(() => forward(operation));
    }
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message }) =>
        console.error('[GraphQL error]:', message)
      );
    }
    if (networkError) {
      console.error('[Network error]:', networkError);
    }
    return undefined;
  });

  // Any mutation may change cached lists (impianti, devices, users...): drop the short request cache.
  const mutationCacheLink = new ApolloLink((operation, forward) => {
    const def = getMainDefinition(operation.query);
    if (def.kind === 'OperationDefinition' && def.operation === 'mutation') requestCache.clear();
    return forward(operation);
  });

  const http = httpLink.create({ uri, withCredentials: true });

  const wsLink = new WebSocketLink({
    uri: wsUri,
    options: {
      reconnect: true,
      connectionParams: async () => {
        const token = await tokens.getValidToken()
          ?? await firstValueFrom(authService.onTokenChange().pipe(
            filter((t): t is NbAuthJWTToken => t instanceof NbAuthJWTToken && t.isValid()),
          ));
        return { headers: hasuraAuthHeaders(token) };
      },
    },
  });

  const link = split(
    ({ query }) => {
      const def = getMainDefinition(query);
      return def.kind === 'OperationDefinition' && def.operation === 'subscription';
    },
    wsLink,
    ApolloLink.from([mutationCacheLink, errorLink, basicLink, authLink, http])
  );

  return {
    link,
    cache: new InMemoryCache(),
    defaultOptions,
  };
}

@NgModule({
  imports: [HttpClientModule],
  exports: [HttpClientModule],
  providers: [
    Apollo, // ✅ <- This is the missing provider
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, NbAuthService, TokenRefreshService, RateLimitNotifier, RequestCacheService],
    },
  ],
})
export class GraphQLModule {}
